import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import './styles.css';


class Modal extends Component {
  render() {
    const { children, open, label } = this.props
    return (
      <ReactModal
      className="ReactModal__Content"
      isOpen={open}
      shouldCloseOnEsc={false}
      contentLabel={label}
      ariaHideApp={false}
      // contentRef={setContentRef}
      >
      {children}
      </ReactModal>
    )
  }
};

Modal.propTypes = {
  children: PropTypes.node, 
  open: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
}

export default Modal;


// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js